import { combineReducers } from 'redux';

import authReducer from './auth.reducer';
import userReducer from './user.reducer';
import desktopAppReducer from './desktopApp.reducer';
import { objectReducer } from './object.reducer';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  desktopApp: desktopAppReducer,
  object: objectReducer,
});

/**
 *
 * @param state
 * @param action
 * @returns
 */
const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
